import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { LinkButton } from '../../UI/LinkButton';
import { colors } from '../../../styles/colors';
import { getStringWithUpperFirstChar } from '../../../functions/getStringWithUpperFirstChar';

const Container = styled.div`
    width: 420px;
    height: 450px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: 321px) and (max-width: 767.98px) {
        width: 100%;
        max-width: 420px;
        height: 380px;
        margin: 0;
        margin-bottom: 6.25rem;
        padding: 1rem;
    }
    @media (max-width: 320px) {
        width: 100%;
        height: 350px;
        margin: 0;
        margin-bottom: 6.25rem;
        padding: 1rem;
    }

    .category-pic {
        width: 100%;
        height: 240px;
        background: #ececec url(${props => props.category_picture}) no-repeat 50% 50%;
        background-size: cover;
    }
    .category-title {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 3.75rem;
        line-height: 133%;

        color: ${colors.dark_blue};

        @media (max-width: 320px) {
            font-size: 3rem;
            margin: 2rem 0;
        }
    }
    .link-button {
        align-self: flex-end;

        @media (max-width: 460px) {
            .link {
                font-size: 2.25rem;
            }
        }
    }
`

export const CategoryCard = ({ category_data }) => {

    const location = useLocation().pathname
    const category_name = category_data.category_name
    const category_picture = category_data.category_picture.url

    return (
        <Container className='category-card' category_picture={ category_picture } >
            <div className="category-pic"></div>
            <div className="category-title"> { getStringWithUpperFirstChar(category_name) } </div>
            <LinkButton link={ location + '/' + category_name } text='Перейти в категорию' />
        </Container>
    )
}
